export const getLeadSourceType = (): string | null => {
  const key = 'utm_medium';
  const params = new URLSearchParams(location.search);

  if (params.has(key)) {
    return params.get(key);
  }

  if (
    document.referrer.includes('https://www.google.com') ||
    document.referrer.includes('https://www.bing.com')
  ) {
    return 'organic';
  }

  if (sessionStorage.getItem(key)) {
    return sessionStorage.getItem(key);
  }

  return 'direct';
};

export const getLeadSourceName = (): string | null => {
  const key = 'utm_source';
  const params = new URLSearchParams(location.search);

  if (params.has(key)) {
    return params.get(key);
  }

  if (document.referrer.includes('https://www.google.com')) {
    return 'googleSearch';
  }

  if (document.referrer.includes('https://www.bing.com')) {
    return 'bing';
  }

  if (sessionStorage.getItem(key)) {
    return sessionStorage.getItem(key);
  }

  return 'websiteVisit';
};

export const getLeadSourceCampaign = (): string | null | undefined => {
  const key = 'utm_campaign';
  const params = new URLSearchParams(location.search);

  if (params.has(key)) {
    return params.get(key);
  }

  if (sessionStorage.getItem(key)) {
    return sessionStorage.getItem(key);
  }
};
